import { type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type KbdProps = HTMLAttributes<HTMLElement>;

/**
 * Kbd — keyboard-shortcut hint chip (DESIGN-SYSTEM §5, command palette / menus).
 * Renders a small mono key cap, e.g. <Kbd>⌘</Kbd><Kbd>K</Kbd>.
 */
export function Kbd({ className, children, ...props }: KbdProps) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded border border-border",
        "bg-bg-elevated px-1.5 font-mono text-[11px] font-medium leading-none text-fg-muted",
        className,
      )}
      {...props}
    >
      {children}
    </kbd>
  );
}
Kbd.displayName = "Kbd";
